import React from 'react';
import './Cura.css';

function Cura() {
    return (
        <div>
            <div className="cura__row cura__text-row">
                <p className="text">Lorem ipsum dolor sit amet.</p>
                <p className="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloremque ipsa ipsam labore optio porro praesentium temporibus totam vero. Autem consequuntur deserunt distinctio dolor est facilis quae qui quibusdam repellendus sint? Accusantium at consequatur consequuntur dolore doloribus. Qui, totam, voluptas? Ipsam, repellendus suscipit! Earum esse maiores nisi perferendis possimus rem voluptas voluptate. Asperiores atque deleniti facere neque numquam pariatur praesentium quos ratione repudiandae totam? Dicta, harum optio! A aperiam architecto beatae consequuntur debitis dolores earum enim, eveniet ex, exercitationem facere hic illo impedit in libero maiores neque nulla numquam odio odit possimus quae recusandae ullam veritatis vitae voluptates voluptatum? Eaque, illum?</p>
            </div>
        </div>
    )
}

export default Cura;
